function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 8,
  strokeLinecap: "butt",
  d: "m0.005249344 59.82677l26.922047 -19.30849l0 9.424511l23.020744 0l0 -23.020744l-9.424511 0l19.30849 -26.922047l19.30849 26.922047l-9.424507 0l0 23.020744l23.020744 0l0 -9.424511l26.922043 19.30849l-26.922043 19.30849l0 -9.424507l-23.020744 0l0 23.020744l9.424507 0l-19.30849 26.922043l-19.30849 -26.922043l9.424511 0l0 -23.020744l-23.020744 0l0 9.424507z",
  fillRule: "evenodd"
});

var Svg30Arrow4Way = function Svg30Arrow4Way(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-10 -10 150 150",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg30Arrow4Way, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/30-arrow-4-way.eb5181cc.svg";
export { ForwardRef as ReactComponent };